import { Doctor } from "@/types/schedule";
import { Badge } from "@/components/ui/badge";

interface DoctorSummaryCardProps {
  doctor: Doctor;
}

export const DoctorSummaryCard = ({ doctor }: DoctorSummaryCardProps) => {
  return (
    <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg border">
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <h3 className="font-semibold text-foreground">{doctor.name}</h3>
          <Badge variant={doctor.status === "active" ? "default" : "secondary"}>
            {doctor.status === "active" ? "Ativo" : "Inativo"}
          </Badge>
        </div>
        <p className="text-sm text-muted-foreground">{doctor.specialty}</p>
        <p className="text-sm text-muted-foreground">CRM: {doctor.crm}</p>
      </div>
      <div
        className="w-3 h-3 rounded-full"
        style={{ backgroundColor: doctor.color }}
      />
    </div>
  );
};

